// extracted by mini-css-extract-plugin
export default {"main":"ModalEditarPrueba_main__CuXmr","intro":"ModalEditarPrueba_intro__90NgE","input":"ModalEditarPrueba_input__aQvZc"};